import React from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { DEMO_FLOORPLANS_OPTIONS } from '~/tenants/demo/performable/floorplans/DemoFloorplansJob';
import { DemoOrderContext, DemoOrderType } from '~/tenants/demo/model/DemoOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';

export default function DemoFloorplansForm({ context }: TenantPerformableFormProps<DemoOrderContext>) {
  return (
    <FormHorizontal name="option" label="Option">
      <ZodFieldSelect
        name="option"
        options={Object.entries(DEMO_FLOORPLANS_OPTIONS).map(([id, pkg]) => ({
          value: id,
          label: `(${pkg.from}-${pkg.to} sqft)`,
          disabled:
            context.metadata.type === DemoOrderType.RESIDENTIAL &&
            (context.metadata.sqft > pkg.to || context.metadata.sqft < pkg.from),
        }))}
      />
    </FormHorizontal>
  );
}
